import { isAxiosError } from 'axios';
import { apiErrorMessage } from '@/lib/api-error';

function safeIdentifier(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const normalized = value.trim();
  return /^[a-zA-Z0-9._:-]{1,128}$/.test(normalized) ? normalized : null;
}

function safeMessage(value: string, fallback: string): string {
  if (/<\/?[a-z][^>]*>|<!doctype|https?:\/\/|(?:authorization|bearer|password|secret|token|api[_-]?key)\s*[:=]/i.test(value)) {
    return fallback;
  }
  return value;
}

export function panelErrorMessage(error: unknown, fallback: string): string {
  const message = safeMessage(apiErrorMessage(error, fallback), fallback);
  if (!isAxiosError(error)) return message;

  const data = error.response?.data;
  const bodyRequestId = data && typeof data === 'object'
    ? safeIdentifier((data as Record<string, unknown>).request_id)
    : null;
  const headerRequestId = safeIdentifier(error.response?.headers?.['x-request-id']);
  const status = error.response?.status;
  const requestId = bodyRequestId ?? headerRequestId;
  const details = [status ? `HTTP ${status}` : null, requestId ? `Request ID ${requestId}` : null]
    .filter(Boolean);

  return details.length > 0 ? `${message} · ${details.join(' · ')}` : message;
}
